<script>
import ClockStatusIndicator from "../atoms/ClockStatusIndicator.vue";
import TimeCounter from "../atoms/TimeCounter.vue";
import StatusAwareComponent from "../StatusAwareComponent.vue";

export default {
  name: "ClockStatusButton",
  components: {TimeCounter, ClockStatusIndicator},
  extends: StatusAwareComponent,
  props: {
    time: {
      type: Number,
      required: false,
      default: 0
    }
  }
}
</script>

<template>
  <div class="d-flex gap-2 w-auto align-items-center border-radius px-3 align-self-center h-100 clickable">
    <clock-status-indicator :status="status"/>
    <time-counter v-if="isWorking || isCompleted" :status="status" :time="time"
                  class="text-dark label text-nowrap mb-0 d-none d-lg-block" />
    <p v-else class="text-dark label text-nowrap mb-0 d-none d-lg-block">{{trans('general.component.attendance_clock_widget.clock_in')}}</p>
  </div>
</template>
